<template>
<div>

<v-container>
<v-row wrap>
<v-col>

<v-icon style="font-size:40px;float:left;vertical-align:middle;margin-right:10px">fingerprint</v-icon>
<div class="heading" style="margin:5px 0px 15px 0px">Welcome to Taco</div>
<div v-if="user" style="color:grey;font-size:12px">You are signed in as {{user.email}}&nbsp;
    <a href @click="signOut">Sign Out</a>
</div>
<v-stepper v-model="step" vertical>
    
    <v-stepper-step step="1" v-bind:complete="step > 1">
    Join {{officeName || ' an Office'}}
    <small>Enter credentials to join.</small>
    </v-stepper-step>
    <v-stepper-content step="1">
        <v-text-field hide-details v-model='inviteCode' @change="updateOfficeName" label="Invite Code" ></v-text-field>
        <v-text-field hide-details v-model='pin' type="password" label="Pin Number"></v-text-field> 
        <v-btn @click.native="joinOffice" class="primary mt-3" dark>Join</v-btn>  
    </v-stepper-content>

    <v-stepper-step step="2" v-bind:complete="step > 2">Create your profile</v-stepper-step>
    <v-stepper-content step="2">
        <v-text-field hide-details v-model='user.firstName' label="First Name" browser-autocomplete="false"></v-text-field>
        <v-text-field hide-details v-model='user.lastName' label="Last Name" browser-autocomplete="false" ></v-text-field>
        <v-text-field hide-details v-model='user.email' label="Email" browser-autocomplete="false" ></v-text-field>
        <v-text-field hide-details v-model='user.mobile' label="Mobile"></v-text-field>
        <v-btn @click.native="createProfile" class="primary mt-3">Create</v-btn>
    </v-stepper-content>
    <v-stepper-step step="3" v-bind:complete="step > 3">Start using Taco</v-stepper-step>
    <v-stepper-content step="3">
            Gracias. You are ready to begin. To find out more about Taco, <a target="_blank" href="https://www.google.com/search?q=taco">click here</a>
            <br/><br/>
        <v-btn class="primary mt-3" @click.native="$router.push('/home')">Start Using Taco</v-btn>
    </v-stepper-content>
</v-stepper>

    
        
        </v-col>
    </v-row>
</v-container>

<v-snackbar :timeout="4000" v-model="snackbarShow" >
    {{ snackbar }}
    <v-icon class="white--text">fingerprint</v-icon>
</v-snackbar>

</div>
</template>

<script>

import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'
import DataHelpers from '../helpers/DataHelpers'
import DateHelpers from '../helpers/DateHelpers'


var db = firebase.database()

export default {
    name: 'Join',
    data() {
        return {
            officeName: '',
            step: 1,
            inviteCode: '',
            pin: '',
            snackbar: '',
            snackbarShow: false,
            user: {
                firstName: null,
                lastName: null,
                email: null,
                mobile: null
            }
        }
    },
    computed: {
        googleUser() {
            return firebase.auth().currentUser || {}
        }
    },
    methods: {
        signOut() {
            firebase.auth().signOut()
        },
        updateOfficeName(newValue) {
            console.log('updating')
            if(!newValue) {
                this.officeName = ''
                return
            }
            let ref = DataHelpers.getRootRef().child('invites').child(newValue)
            
            ref.once('value', snap => {
                let invite = snap.val()
                if(invite)
                    this.officeName = invite.name
                else
                    this.officeName = ''
            })
        },
        joinOffice () {
            //TODO: store and compare with md5 encryption
            let vm = this
            const uid = this.$store.getters.uid
            const user = this.$store.getters.user

            let ref = db.ref('invites/' + this.inviteCode)
            
            ref.child('write').once('value', function(snap) {
                
                if(snap.val() == vm.pin) {
                    console.log('success for writing')
                    user.office = {
                        key: vm.inviteCode
                    }
                    user.tenantKey = vm.inviteCode
                    let usersRef = db.ref('users').child(uid)
                    usersRef.update(user)
                    usersRef.child('offices').child(vm.inviteCode).update({
                        read: true,
                        write: true,
                        active: true,
                        name: vm.officeName
                    })
                    window.location.href='/join?step=2&inviteCode=' + vm.inviteCode
                }
                else {
                    vm.snackbar = 'Failed to join. Please check credentials'
                    vm.snackbarShow = true
                }

            }, function(error){
                console.log(error)
            })
            console.log('got here')
        },

        createProfile () {
            const uid = this.$store.getters.uid
            let contactsRef = db.ref('tenants').child(this.inviteCode).child('contacts')
            let user = this.user
            user.created = DateHelpers.todayString()
            user.openedAt = DateHelpers.nowString()
            user.user = true
            delete user.uid
            contactsRef.child(uid).update(user)
            this.step = 3
        }
    },

    created () {
        let vm = this
        DataHelpers.fetchUser(500, true).then(function(user){
            vm.user  = user
        })
        this.inviteCode=this.$route.query.inviteCode || ''
        if(this.$route.query.step == 2)
            this.step = 2

        
    }
}

</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Join.vue?00456968